import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faConciergeBell, faEnvelopeOpenText, faHotel, faListAlt, faCommentAlt, faMapMarked, faBell, faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { NavLink, useLocation } from 'react-router-dom';
import { T } from 'react-translator-component';
import { HotelContext } from '../context/hotel'
import { UserContext } from '../context/user';
import { CheckInContext } from '../context/checkin';
import { usePerson as usePersonContext } from '../context/person';
import { SmartLock2 } from '../components/Icons';
import CustomStyles from '../components/CustomStyles';
import { isHostz, isHostzArosa, isHostzBecozy, isHostzBetaHouse, isHostzBlackSummit, isHostzCozy, isHostzMyde, isHostzSteiners, isHostzSwissstay, isOffgrid, isSimplex, isHostzSigma } from './CheckIn/hotelConditions';


const Navigation = (props) => {
    const { pathname } = useLocation();
    // const navigate = useNavigate();

    // const { Client } = useSelector(state => state.profileReducer);
    // const { data : hotel } = useSelector(state => state.hotelReducer);
    const { data: hotel, getUrlPath } = useContext(HotelContext);
    const { data: checkIn, webCheckInDone } = useContext(CheckInContext);
    const { inStay, initied, Room, activeRequestsQty, unreadNotificationsQty, doNotDisturb, smartLockPinCode, hasSmartLocks, language } = useContext(UserContext)
    const { data: person } = usePersonContext();

    const { theme } = hotel?.settings || { theme: null };
    const location = useLocation();
    const [tabs, setTabs] = useState([]);
    const [showNav, setShowNav] = useState(false);
    // const [showBackButton, setShowBackButton] = useState(false);
    const [showContactButton, setShowContactButton] = useState(false);
    const styles = CustomStyles(hotel?.id);


    // const listenToPopstate = () => {
    //     setLocation(getCurrentLocation())
    // };

    // React.useEffect(() => {
    //     console.log('aaaa')
    //     window.addEventListener("popstate", listenToPopstate);
    //     return () => {
    //       window.removeEventListener("popstate", listenToPopstate);
    //     };
    // }, []);

    // React.useEffect(() => {
    //     const query_params = new URLSearchParams(location.search)

    //     let _pathname_arr = location?.pathname.split('/');
    //     if (location.search === '?system-reset-data' || _pathname_arr[_pathname_arr.length-1] === 'logout') {
    //         dispatch({ type: 'RESTART_DATA' })
    //         // history.push(`/${hotel.code}`)
    //         navigate(`/${hotel.code}`)
    //     }
    //     // const _theme = query_params.get('theme')
    //     // if (_theme != null && _theme != hotel.settings.theme) {
    //     //     dispatch({ type: 'HOTEL_FORCE_THEME', theme : _theme })
    //     // }

    //     // const _lang = query_params.get('lang')
    //     // if (_lang != null && _lang != language) {
    //     //     dispatch({ type: 'HOTEL_SET_LANGUAGE', language : _lang })
    //     // }
    // }, [location, hotel]);

    React.useEffect(() => {

        window.scrollTo(0, 0);
        let _pathname = location.pathname;
        if (_pathname[_pathname.length - 1] === '/') {
            _pathname = _pathname.slice(0, -1);
        }

        // let _pathname_arr = _pathname.split('/');
        // console.log(_pathname_arr[_pathname.length - 2])
        // if (_pathname_arr[_pathname_arr.length - 2] == 'identify') {
        //     alert('Identificar al ' + _pathname_arr[_pathname_arr.length - 1]);
        // }
        // TODO::: hacer mejor
        // const _showNavMenu = _pathname == '/' + hotel.code || 
        //                      _pathname == '/' + hotel.code + '/services' ||
        //                      _pathname == '/' + hotel.code + '/account' ||
        //                      _pathname == '/' + hotel.code + '/requests';
        // const _showNavMenu = !(
        //     _pathname === '/' + hotel.code + '/checkin' || 
        //     _pathname.startsWith('/' + hotel.code + '/checkin/identify') ||
        //     _pathname.startsWith('/' + hotel.code + '/checkin/edit') ||
        //     _pathname.startsWith('/' + hotel.code + '/notifications/') ||
        //     _pathname.startsWith('/' + hotel.code + '/service') ||
        //     _pathname.startsWith('/' + hotel.code + '/restaurants') ||
        //     _pathname.startsWith('/' + hotel.code + '/welcome') ||
        //     _pathname.startsWith('/' + hotel.code + '/requests') ||
        //     _pathname.startsWith('/' + hotel.code + '/system') ||
        //     _pathname.startsWith('/' + hotel.code + '/add-device') ||
        //     _pathname.startsWith('/' + hotel.code + '/location') ||
        //     _pathname.startsWith('/' + hotel.code + '/info') ||
        //     _pathname.startsWith('/' + hotel.code + '/booking') ||
        //     _pathname.startsWith('/' + hotel.code + '/service_booking') || 
        //     _pathname.startsWith('/' + hotel.code + '/meeting_rooms') ||
        //     _pathname.startsWith('/' + hotel.code + '/rooms') ||
        //     _pathname.startsWith('/' + hotel.code + '/facilities')
        // )
        const _showNavMenu = (
            _pathname.endsWith('/home') ||
            _pathname.endsWith('/stay') ||
            _pathname.endsWith('/services') ||
            _pathname.endsWith('/notifications') ||
            _pathname.endsWith('/stay') ||
            _pathname.endsWith('/smartLock') ||
            _pathname.endsWith('/checkin/status') ||
            _pathname.endsWith('/location') ||
            _pathname.endsWith('/settings') ||
            _pathname.endsWith('/public') ||
            _pathname.endsWith('/public/')
        )
        // const _showBackButton = !_showNavMenu;
        const _showContactButton = _showNavMenu && !(
            _pathname.endsWith('/stay') ||
            _pathname.endsWith('/requests')
        );
        setShowNav(_showNavMenu);
        props.setShowNavigation(_showNavMenu)
        // setShowBackButton(_showBackButton);
        setShowContactButton(_showContactButton);
    }, [hotel, location]);



    useEffect(() => {
        if (inStay && initied) {
            setTabs([
                { code: 'info', route: getUrlPath("home"), icon: theme !== 1 ? faHotel : null, image: theme === 1 ? '/icons/hotel.png' : null, label: T("Info") },
                { code: 'requests', route: getUrlPath("services"), icon: theme !== 1 ? faConciergeBell : null, image: theme === 1 ? '/icons/request.png' : null, label: T("Request"), badge: !isNaN(activeRequestsQty) && activeRequestsQty > 0 ? activeRequestsQty : false },
                {
                    code: 'hab',
                    route: isHostz(hotel.id) ? (getUrlPath("smartlock-general")) : ((smartLockPinCode || hasSmartLocks) ? getUrlPath("smartlock") : null),
                    icon: null,
                    label: 'Hab'
                },
                { code: 'notifications', route: getUrlPath("notifications"), icon: theme !== 1 ? faBell : null, image: theme === 1 ? '/icons/notification.png' : null, label: T("Notifications"), badge: !isNaN(unreadNotificationsQty) && unreadNotificationsQty > 0 ? unreadNotificationsQty : false },
                {
                    code: 'status',
                    route: getUrlPath("checkin/status"),
                    icon: theme !== 1 ? faListAlt : null,
                    image: theme === 1 ? '/icons/checkin.png' : null,
                    label: T("Status"),
                    badge: checkInBadge ? '' : undefined
                },
                // ,{
                //     route: `${hotel.code}/profile`, icon: faUserCircle, label: "Mi Perfil"
                // }
            ])
            // if (!initied) {
            //     // history.push(`/${hotel.code}/welcome`)
            // }
        } else {

            let urlCheckinCustom = "";
            if (isHostzBetaHouse(hotel.id)) {
                // urlCheckinCustom = "https://wa.me/41782247770";
                urlCheckinCustom = "https://wa.me/41445052256";
            }
            if (isHostzBecozy(hotel.id)) {
                urlCheckinCustom = "https://wa.me/41783126350";
            }
            if (isHostzMyde(hotel.id)) {
                urlCheckinCustom = "https://wa.me/4915566511786";
            }
            if (isHostzArosa(hotel.id)) {
                urlCheckinCustom = "https://wa.me/41798073777";
            }
            if (isHostzCozy(hotel.id)) {
                urlCheckinCustom = "https://wa.me/41798076888";
            }
            if (isHostzSwissstay(hotel.id)) {
                urlCheckinCustom = "https://wa.me/41798077220";
            }
            if (isHostzSteiners(hotel.id)) {
                urlCheckinCustom = "https://wa.me/41755730222";
            }
            if (isOffgrid(hotel.id)) {
                urlCheckinCustom = "https://wa.me/493054806375";
            }
            if (isSimplex(hotel.id)) {
                urlCheckinCustom = "https://wa.me/497219098790";
            }
            if (isHostzSigma(hotel.id)) {
                urlCheckinCustom = "https://wa.me/41445052256";
            }

            setTabs([
                {
                    code: 'info',
                    route: getUrlPath("home"),
                    icon: theme !== 1 ? faHotel : null,
                    image: theme === 1 ? '/icons/hotel.png' : null,
                    label: T("Info")
                },
                {
                    code: 'location',
                    route: getUrlPath("location"),
                    icon: theme !== 1 ? faMapMarked : null,
                    image: theme === 1 ? '/icons/location.png' : null,
                    label: T("Location")
                },
                {
                    code: 'checkin',
                    route: getUrlPath("checkin"),
                    icon: theme !== 1 ? faListAlt : null,
                    image: theme === 1 ? '/icons/checkin.png' : null,
                    label: T("Check-In"),
                    badge: checkInBadge ? '' : undefined,
                    linkExternal: !webCheckInDone ? urlCheckinCustom : ""
                },
                ...(webCheckInDone ? [{
                    code: 'contact',
                    route: getUrlPath("services/service_general"),
                    icon: theme !== 1 ? faCommentAlt : null,
                    image: theme === 1 ? '/icons/contact.png' : null,
                    label: T("Contact"),
                    linkExternal: urlCheckinCustom
                }] : [])
            ]);

        }

        // Tabs para usuarios públicos logueados
        if (person?.fullname) {
            setTabs([
                {
                    code: 'info',
                    route: getUrlPath("home"),
                    icon: theme !== 1 ? faHotel : null,
                    image: theme === 1 ? '/icons/hotel.png' : null,
                    label: T("Info")
                },
                {
                    code: 'map',
                    route: getUrlPath("location"),
                    icon: theme !== 1 ? faMapMarked : null,
                    image: theme === 1 ? '/icons/location.png' : null,
                    label: T("Location")
                },
                {
                    code: 'person',
                    route: getUrlPath("public/"),
                    icon: theme !== 1 ? faUser : null,
                    image: theme === 1 ? '/icons/person.png' : null,
                    label: T("Person")
                }
            ]);
        }


    }, [hotel?.code, inStay, initied, language, activeRequestsQty, checkIn?.status, unreadNotificationsQty, theme, smartLockPinCode, person?.fullname]);

    const checkInBadge = useMemo(() => {
        if (!checkIn) return false;

        if (checkIn?.status === 'pending' || checkIn?.status === 'to_validate' || checkIn?.status === 'observed') {
            return true;
        }

        if (inStay && !initied) {
            return true;
        }

        return false;
    }, [checkIn, inStay, initied])




    return (
        <div className="navbar-container" key={`navbar-${language}`}>
            {false && showContactButton && hotel.whatsapp && <a className={'float-contact-button'} href={`https://wa.me/${hotel.whatsapp}`}><FontAwesomeIcon style={{ fontSize: "24", paddingLeft: '0px', color: '#FFF' }} icon={faCommentAlt} /></a>}
            {/* Top Bar*/}
            {/* <nav className="navbar navbar-expand-md navbar-light d-none d-lg-block sticky-top" role="navigation">
                <div className="container-fluid">
                    <a className="navbar-brand" href="/">Home</a>
                    <Nav className="ml-auto">
                    <NavItem>
                        <NavLink to="/hotel" className="nav-link">
                        Hotel
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/login" className="nav-link">
                        Login
                        </NavLink>
                    </NavItem>
                    </Nav>
                </div>
            </nav> */}

            {/* Bottom Tab Navigator*/}
            {showNav && <nav className="navbar navbar-light d-flex bottom-tab-nav" style={{ flex: 1 }} role="navigation">
                <Nav className="w-100">
                    <div className=" d-flex flex-row justify-content-around w-100">
                        {
                            tabs.map((tab, index) => (
                                <NavItem id={`nav-item-${tab.code}`} key={`tab-${index}`} style={{ width: '20%' }}>
                                    <NavLink
                                        to={tab.route}
                                        onClick={(e) => {
                                            if (tab.linkExternal) {
                                                e.preventDefault();
                                                window.open(tab.linkExternal, '_blank');
                                            }
                                        }}
                                        className={`nav-link bottom-nav-link ${tab.code === "checkin" && location.pathname === `/${hotel.code}/status` ? "active" : ""} ${tab.badge !== undefined && tab.badge !== false ? 'with-badge' : ''}`}
                                        data-badge={tab.badge}
                                        exact={"true"}
                                        state={{ from: pathname }}
                                    >
                                        {tab.label === 'Hab' && !tab.route && Room.id && <div className="info-block">
                                            <div className={`info-block-content ${doNotDisturb ? 'status-not-disturb' : ''}`}>
                                                {!styles?.ApartYou && <small>{T('checkin.short-room')}</small>}
                                                {Room && Room.code.length <= 9 ?
                                                    (styles?.ApartYou ? <div style={styles?.ApartYou}>Apart You</div> : <span>{Room ? Room.code : '???'}</span>) :
                                                    <div style={styles?.ApartYou ? styles?.ApartYou : { fontSize: 9, lineHeight: 1, color: '#666666', textTransform: 'uppercase', marginTop: 4 }}>{styles?.ApartYou ? 'Apart You' : (Room ? Room.code : '???')}</div>
                                                }
                                                {doNotDisturb && <small className="not-disturb text-white">{T('checkin.do-not-disturb')}</small>}
                                            </div>
                                        </div>}
                                        {tab.label === 'Hab' && tab.route && Room.id && <div className="info-block">
                                            <div className={`info-block-content smart-lock`}>
                                                <div>
                                                    {!styles?.ApartYou && <small>{T('checkin.short-room')}</small>}
                                                    {Room && Room.code.length <= 9 ?
                                                        (styles?.ApartYou ? <div style={styles?.ApartYou}>Apart You</div> : <span>{Room ? Room.code : '???'}</span>) :
                                                        <div style={styles?.ApartYou ? styles?.ApartYou : { fontSize: 9, lineHeight: 1, color: '#666666', textTransform: 'uppercase', marginTop: 4 }}>{styles?.ApartYou ? 'Apart You' : (Room ? Room.code : '???')}</div>
                                                    }
                                                </div>
                                                <div style={{ marginTop: -7 }}>
                                                    <SmartLock2 width={doNotDisturb ? 32 : 40} height={doNotDisturb ? 32 : 40} color="#666" />
                                                </div>
                                                {doNotDisturb && <small style={{ fontSize: 11, bottom: 18 }} className="not-disturb text-white">{T('checkin.do-not-disturb')}</small>}
                                            </div>
                                        </div>}
                                        {tab.label !== 'Hab' && <div className="row d-flex flex-column justify-content-center align-items-center">
                                            {tab.icon && <FontAwesomeIcon icon={tab.icon} />}
                                            {tab.image && <img src={tab.image} alt="" />}
                                            <div className="bottom-nav-link-label">{tab.label}</div>
                                        </div>}
                                    </NavLink>
                                </NavItem>
                            ))
                        }
                    </div>
                </Nav>
            </nav>}
        </div>
    )
}

export default Navigation;
